import { Badge } from "../Badge"
import { INVITE_STATUS_BADGE_VARIANTS } from "../../constants/inviteStatusBadges"
import { INVITE_STATUS_LABELS } from "../../constants/inviteStatus"

export const InvitationStatusBadge = ({ status }) => {
  const variant = INVITE_STATUS_BADGE_VARIANTS[status] || "locked"
  const text = INVITE_STATUS_LABELS[status] || status

  return <Badge variant={variant} text={text} />
}
